var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "15px",
    viewBox: "0 0 24 15",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "full-battery"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5073 15L2.50094 15C1.12142 15 0 13.878 0 12.5L0 2.5C0 1.122 1.12142 0 2.50094 0L19.5073 0C20.8868 0 22.0083 1.122 22.0083 2.5L22.0083 3L22.4994 3C23.3267 3 24 3.673 24 4.5L24 10.5C24 11.327 23.3267 12 22.4994 12L22.0083 12L22.0083 12.5C22.0083 13.878 20.8868 15 19.5073 15ZM2.50094 1C1.67363 1 1.00038 1.673 1.00038 2.5L1.00038 12.5C1.00038 13.327 1.67363 14 2.50094 14L19.5073 14C20.3346 14 21.0079 13.327 21.0079 12.5L21.0079 11.5C21.0079 11.224 21.232 11 21.5081 11L22.4994 11C22.7745 11 22.9996 10.776 22.9996 10.5L22.9996 4.5C22.9996 4.224 22.7745 4 22.4994 4L21.5081 4C21.232 4 21.0079 3.776 21.0079 3.5L21.0079 2.5C21.0079 1.673 20.3346 1 19.5073 1L2.50094 1Z",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9L0.5 9C0.224 9 0 8.776 0 8.5L0 0.5C0 0.224 0.224 0 0.5 0L3.5 0C3.776 0 4 0.224 4 0.5L4 8.5C4 8.776 3.776 9 3.5 9ZM1 8L3 8L3 1L1 1L1 8Z",
    transform: "translate(3 3)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9L0.5 9C0.224 9 0 8.776 0 8.5L0 0.5C0 0.224 0.224 0 0.5 0L3.5 0C3.776 0 4 0.224 4 0.5L4 8.5C4 8.776 3.776 9 3.5 9ZM1 8L3 8L3 1L1 1L1 8Z",
    transform: "translate(9 3)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9L0.5 9C0.224 9 0 8.776 0 8.5L0 0.5C0 0.224 0.224 0 0.5 0L3.5 0C3.776 0 4 0.224 4 0.5L4 8.5C4 8.776 3.776 9 3.5 9ZM1 8L3 8L3 1L1 1L1 8Z",
    transform: "translate(15 3)",
    id: "Shape",
    fill: "#000000",
    stroke: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullBattery);
export default __webpack_public_path__ + "static/media/full-battery.610675228bdd8ab9309504fbd0ba219d.svg";
export { ForwardRef as ReactComponent };